module.exports = __webpack_public_path__ + "img/partner-app.f2812f1e.png";